module.exports = __webpack_public_path__ + "media/customizations/lmws/logo-37577b6a92cc6abef50dbcf33f478740.png";